/* eslint-disable jsx-a11y/anchor-is-valid */

import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

import FormController from "../../../FormController/FormController";
import { getGamesByPrice } from "../../../../features/cms/cmsSlice";
import FormTitle from "../../../FormTitle/FormTitle";
import CustomTabs from "../../components/CustomTabs/idnex";
import { GameItemList } from "../../components/GameItemList/GameItemList";

const ByPrice = () => {
  const history = useHistory();
  const { type } = useSelector((state) => state?.singleGroup);
  const games = useSelector(getGamesByPrice);
  const [tabs, setTabs] = useState();
  const pricelabels = {
    valueGames: "Value Games",
    regularGames: "Regular Games",
    primeGames: "Prime Games",
    marqueeGames: "Marquee Games",
    // diamondGames: "Diamond Games",
  };

  useEffect(() => {
    if (!type) history.push("/");

    if (!tabs) {
      const _tabs = Object.keys(games).map((d) => {
        return {
          id: d,
          label: pricelabels[d],
          featured: d === "valueGames" ? "true" : "",
          comp: <GameItemList games={games[d]} />,
        };
      });
      setTabs(_tabs);
    }
  }, [games, history, pricelabels, tabs, type]);

  return (
    <div>
      <FormTitle title="by Price" />
      <div>
        {tabs && (
          <CustomTabs
            tabs={tabs}
            activeTab={history.location.state?.data}
            trackingTitle="Games By Price"
          />
        )}
      </div>
      <FormController
        backTo="/ticket-single-group/by-price-landing"
        startOver="/"
        showBack
        showStartOver
      />
    </div>
  );
};

export default ByPrice;
